(function() {
  function insertScript(src) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    // Don't enable async loading, since vendor.js must be loaded first (but
    // this parent embed.js script can be loaded async).
    script.async = false;
    // Include scripts with crossorigin=anonymous to improve ability to report
    // javascript errors to rollbar.
    script.crossOrigin = 'anonymous';
    script.src = src;
    document.body.appendChild(script);
  }

  function insertStyle(src) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = src;
    document.body.appendChild(link);
  }

  insertStyle('https://fonts.googleapis.com/css?family=Karla:400,400i,700,700i');
  insertStyle('https://widgets.nrel.gov/afdc/station-locator/css/app.2d4ea1ff.css');

  insertScript('https://widgets.nrel.gov/afdc/station-locator/js/chunk-vendors.c7debdc4.js');
  insertScript('https://widgets.nrel.gov/afdc/station-locator/js/app.13c1cd31.js');
})();
